import { pgTable, text, boolean, timestamp, integer, index, uniqueIndex, numeric, foreignKey } from 'drizzle-orm/pg-core';
import { sql } from 'drizzle-orm';

/**
 * Currency - Поддерживаемые валюты системы
 * Хранит информацию о валютах для мультивалютного ценообразования
 */
export const currency = pgTable('Currency', {
  // ISO 4217 код валюты (USD, UZS, RUB)
  code: text().primaryKey(),

  // Название валюты
  name: text().notNull(),

  // Символ валюты ($, сум, ₽)
  symbol: text().notNull(),

  // Количество знаков после запятой
  decimalPlaces: integer().default(2).notNull(),

  // Активна ли валюта для использования
  isActive: boolean().default(true).notNull(),

  // Порядок отображения
  order: integer().default(0).notNull(),

  createdAt: timestamp({ precision: 3, mode: 'date' }).default(sql`CURRENT_TIMESTAMP`).notNull(),
  updatedAt: timestamp({ precision: 3, mode: 'date' }).$onUpdate(() => new Date()).notNull(),
}, (table) => [
  index('Currency_isActive_idx').using('btree', table.isActive.asc().nullsLast()),
  index('Currency_order_idx').using('btree', table.order.asc().nullsLast()),
]);

/**
 * ExchangeRate - Курсы обмена валют
 * Хранит текущие курсы с указанием провайдера
 */
export const exchangeRate = pgTable('ExchangeRate', {
  id: integer().primaryKey().generatedAlwaysAsIdentity(),

  // Валюта источник
  fromCurrency: text().notNull(),

  // Валюта назначения
  toCurrency: text().notNull(),

  // Курс (fromCurrency * rate = toCurrency)
  rate: numeric({ precision: 18, scale: 8 }).notNull(),

  // Провайдер, от которого получен курс
  provider: text().notNull(), // exchangerate-api, openexchangerates, fixer, cbr

  // Когда был получен курс
  fetchedAt: timestamp({ precision: 3, mode: 'date' }).notNull(),

  createdAt: timestamp({ precision: 3, mode: 'date' }).default(sql`CURRENT_TIMESTAMP`).notNull(),
}, (table) => [
  index('ExchangeRate_fromTo_idx').using('btree', table.fromCurrency.asc().nullsLast(), table.toCurrency.asc().nullsLast()),
  index('ExchangeRate_fetchedAt_idx').using('btree', table.fetchedAt.asc().nullsLast()),
  uniqueIndex('ExchangeRate_from_to_unique').using('btree', table.fromCurrency.asc().nullsLast(), table.toCurrency.asc().nullsLast()),
  foreignKey({
    columns: [table.fromCurrency],
    foreignColumns: [currency.code],
    name: 'ExchangeRate_fromCurrency_fkey'
  }).onUpdate('cascade').onDelete('cascade'),
  foreignKey({
    columns: [table.toCurrency],
    foreignColumns: [currency.code],
    name: 'ExchangeRate_toCurrency_fkey'
  }).onUpdate('cascade').onDelete('cascade'),
]);
